import { render, staticRenderFns } from "./update-modal.vue?vue&type=template&id=2c781b73&scoped=true"
import script from "./update-modal.vue?vue&type=script&lang=js"
export * from "./update-modal.vue?vue&type=script&lang=js"
import style0 from "./update-modal.vue?vue&type=style&index=0&id=2c781b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c781b73",
  null
  
)

export default component.exports